import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type BulkActionType } from '@blaze-shared/workflow-domain';

export const generateBulkAction = createAction(
  '[Bulk Actions] Generate bulk action',
  props<{
    elementId: CanvasElementId;
    actionType: BulkActionType;
    workflowIdPath: string;
  }>(),
);

export const removeBulkAction = createAction(
  '[Bulk Actions] Remove bulk action',
  props<{
    elementId: CanvasElementId;
    actionType: BulkActionType;
  }>(),
);
